import {Keys} from "@/constants/key";
import {SquareButton} from "@/scenes.ui/square-button";
import TextUtils from "@/utils/text-utils";
import CU from "../utils/c-u";

export class PriceButtonPanel extends Phaser.GameObjects.Container {
    constructor(scene: Phaser.Scene, price: number, text: string, callback: () => unknown) {
        super(scene);

        this.scene = scene;
        this.width = CU.CANVAS_WIDTH;

        let button = new SquareButton(this.scene, 300, 90, 0, Keys.UI_ART_GREEN_BUTTON,
            undefined, Keys.IC_100_MITHRIL, text, false);
        button.setCallback(() => {
            callback();
        });

        let priceText = TextUtils.addText(this.scene, String(price), 300, button.y / CU.S + 34, '#ffffff',
            25, 'bold', 200);

        this.height = 200;

        this.add([button, priceText]);
    }

}
